<div #routeContainer class="login-route-container">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
<lib-notifications></lib-notifications>
